import { IBrandingOverrides, Role } from "./types";

export const applyUserOverrides = (branding: IBrandingOverrides, user: Role): IBrandingOverrides => {
  const updatedBranding: IBrandingOverrides = { ...branding };
  const userPermissions = updatedBranding.permissions.serviceRequestStatus[user];
  if (!userPermissions) {
    console.warn(`No permissions found for user role: ${user}`);
    return updatedBranding;
  }
  updatedBranding.permissions.serviceRequestStatus.current = {
    ...updatedBranding.permissions.serviceRequestStatus[user],
  }
  return updatedBranding;
}